module.exports = __webpack_public_path__ + "static/img/siteBase.59ebee0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/siteBase.png
// module id = NrNU
// module chunks = 6